"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _defaultTheme = _interopRequireDefault(require("../../defaultTheme"));
var _getViewportHideStyles = _interopRequireDefault(require("../../Hide/helpers/getViewportHideStyles"));
var _Card = require("../../Card");
var _mediaQuery = require("../../utils/mediaQuery");
var _consts = require("../../utils/mediaQuery/consts");
const StyledColumn = _styledComponents.default.div.withConfig({
  displayName: "LayoutColumn__StyledColumn",
  componentId: "sc-aa57pk-0"
})(["", ""], ({
  theme,
  spanEntireRow,
  hideOn
}) => (0, _styledComponents.css)(["", ";", ";@media (max-width:", "px){", "{margin-right:-", ";margin-left:-", ";width:auto;}}"], !!hideOn && (0, _getViewportHideStyles.default)(hideOn), spanEntireRow && (0, _styledComponents.css)(["grid-column:1 / -1;"]), +(0, _mediaQuery.getBreakpointWidth)(_consts.QUERIES.LARGEMOBILE, theme, true) - 1, _Card.StyledCard, theme.orbit.spaceMedium, theme.orbit.spaceMedium));
StyledColumn.defaultProps = {
  theme: _defaultTheme.default
};
const LayoutColumn = ({
  children,
  hideOn,
  as = "div",
  spanEntireRow,
  dataTest
}) => {
  return (
    /*#__PURE__*/
    // @ts-expect-error TODO
    React.createElement(StyledColumn, {
      "data-test": dataTest,
      hideOn: hideOn,
      as: as,
      spanEntireRow: spanEntireRow
    }, children)
  );
};
var _default = LayoutColumn;
exports.default = _default;